import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({
  name: 'safehtml',
  standalone: true
})
export class SafehtmlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(html: any) {
    if (!html) return html;

    let decoded = html;
    let previous = '';
    while (decoded !== previous) {
      previous = decoded;
      const txt = document.createElement('textarea');
      txt.innerHTML = decoded;
      decoded = txt.value;
    }

    return this.sanitizer.bypassSecurityTrustHtml(decoded);
  }

}